import * as React from "react";
import { SVGProps } from "react";
export function SquarePenIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={14}
      height={14}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#square-pen_svg__a)"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7 1.75H3.083c-.797 0-1.333.536-1.333 1.333v7.834c0 .797.536 1.333 1.333 1.333h7.834c.797 0 1.333-.536 1.333-1.333V6.833" />
        <path d="M10.731 1.531a.683.683 0 0 1 .969 0l.769.77c.268.268.268.7 0 .968L8.15 7.586c-.153.154-.35.261-.566.324l-1.72.501c-.196.058-.334-.08-.275-.276l.501-1.72c.063-.216.17-.413.323-.566L10.73 1.53Z" />
      </g>
      <defs>
        <clipPath id="square-pen_svg__a">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
